export default __webpack_public_path__ + "static/media/menu28.2d0228ed.svg";